import { watchers as apiWatchers } from '@va/dashboard/sagas/api';
import { watchers as appWatchers } from '@va/dashboard/sagas/app';
import { watchers as uiWatchers } from '@va/dashboard/sagas/ui';

export const watchers = [uiWatchers(), appWatchers(), apiWatchers()];
